export const ARImportTemplateForm = [
  {
    header: {
      header: 'DocDate',
      width: 17,
    },
    dataType: 'date',
  },
  {
    header: {
      header: 'TransactionDate',
      width: 17,
    },
    dataType: 'date',
  },
  {
    header: {
      header: 'DocNo',
      width: 17,
    },
  },
  {
    header: {
      header: 'RefNo',
      width: 17,
    },
  },
  {
    header: {
      header: 'Description',
      width: 40,
    },
  },
  {
    header: {
      header: 'DebtorName',
      width: 30,
    },
  },
  {
    header: {
      header: 'HeaderRemark',
      width: 30,
    },
  },
  {
    header: {
      header: 'e-Invoice',
      width: 10,
    },
    dataType: 'TrueOrFalse',
  },
  {
    header: {
      header: 'ItemName',
      width: 17,
    },
  },
  {
    header: {
      header: 'DepartmentCode',
      width: 17,
    },
  },
  {
    header: {
      header: 'TaxSchemeName',
      width: 17,
    },
  },
  {
    header: {
      header: 'Amount',
      width: 15,
    },
    dataType: 'amount',
  },
  {
    header: {
      header: 'ItemRemark',
      width: 40,
    },
  },
]
